import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveBiddingUrl } from '@/utils/urls';
import { getLocale } from '@/redux/modules/intl';
import { isUiMobile } from '@/redux/modules/browser';
import { MouseEvent, useCallback } from 'react';
import { popupCenter } from '@/utils/popupCenter';
import { useAppSelector } from '@/redux/hooks';
import { useNavigate } from 'react-router-dom';

const WIDTH = 1248;
const HEIGHT = 800;

type Props = {
    catalogId: number;
};

export const useEnterLiveAuction = ({ catalogId }: Props) => {
    const locale = useAppSelector(getLocale);
    const mobile = useAppSelector(isUiMobile);
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const navigate = useNavigate();

    return useCallback(
        (event: MouseEvent<HTMLElement>) => {
            const localePath = locale === 'en-gb' ? `/${locale}` : '';

            /**
             * Enable either mobile devices or holding down the shift key to open the console in the same window.
             */

            if (Boolean(mobile) || event.shiftKey) {
                navigate(getLiveBiddingUrl(catalogId));
            } else {
                popupCenter({
                    height: HEIGHT,
                    title,
                    url: localePath + getLiveBiddingUrl(catalogId),
                    width: WIDTH,
                });
            }
        },
        [catalogId, locale, mobile, navigate, title]
    );
};
